import React, { useState, useEffect } from 'react';
import {ListProducts} from "./ListProducts";
import {formatTextWithLineBreaks} from "../utils/helper";

export const PinPayment = (props) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const [token, setToken] = useState(localStorage.getItem('jwtToken') || '');
    const [userId, setUserId] = useState('');
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');

    const handleLogin = async () => {
        try {
            const res = await fetch('https://webapi.dgapi.me/auth?tenant=TLEMURIA', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, password }),
            });
            const data = await res.json();

            if (res.ok) {
                console.log("Login exitoso:", data);
                // guardar JWT u otra lógica
                localStorage.setItem('jwtToken', data.result);
                localStorage.setItem('userEmail', data.email);
                setToken(data.result);
                setUserId(data.id_account.toString());
                setEmail(data.email);
            } else {
                alert(data.message || 'Login fallido');
            }
        } catch (err) {
            console.error(err);
            alert('Error al conectar con el servidor');
        }
    };

    const handlePayment = () => {
        // Aquí va la lógica para iniciar el proceso de pago
        console.log('Iniciando pago para ID:', userId);
    };

    const handleLogout = () => {
        localStorage.removeItem('jwtToken');
        setToken('');
        setUserId('');
    };

    useEffect(() => {
        if (token) {
            try {
                const payload = JSON.parse(atob(token.split('.')[1]));
                setUserId(payload.username || '');
            } catch (e) {
                console.error('Error decoding token:', e);
                setUserId('');
            }
        }
    }, [token]);

    return (
        <>
            {!token ? (
                <div className="login-container">
                    <div className="login-box">
                        <h2>Iniciar sesión</h2>
                        <input
                            type="text"
                            placeholder="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                        />
                        <input
                            type="password"
                            placeholder="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        <button onClick={handleLogin}>Next</button>
                    </div>
                </div>
            ) : (
                <div id="payments">

                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-8">
                                <div className="about-text header-section">
                                    <h2>PIN Redeem</h2>
                                    <p></p>
                                    <ListProducts />

                                </div>
                            </div>
                        </div>
                    </div>



                </div>
            )}
        </>
    );
};
